import script from "./CampaignsManagementDetailsQuarantine.vue?vue&type=script&lang=ts&setup=true"
export * from "./CampaignsManagementDetailsQuarantine.vue?vue&type=script&lang=ts&setup=true"

import "./CampaignsManagementDetailsQuarantine.vue?vue&type=style&index=0&id=a84ba9c4&lang=scss"

const __exports__ = script;

export default __exports__